import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(main)/services/ceramic-coating/CeramicCoatingEducation.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(main)/services/ceramic-coating/PackageSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/BookingButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/CtaSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/HeroSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/ParallaxSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReactCompareSlider","ReactCompareSliderImage"] */ "/vercel/path0/node_modules/react-compare-slider/dist/index.mjs");
